import { render, staticRenderFns } from "./SupplierContactCreateView.vue?vue&type=template&id=6c498d00"
import script from "./SupplierContactCreateView.vue?vue&type=script&lang=js"
export * from "./SupplierContactCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports